import { Button, Card, Flex, Typography } from 'antd';
import { Link } from 'react-router-dom';

import IconLogo from '@/assets/icons/logo.svg?react';
import { ROUTES_PATH } from '@/constants/routes.constants';

const { Title, Text } = Typography;

export function NotFoundError() {
  return (
    <Card variant="borderless" className="ant-card-error">
      <Flex vertical align="center" flex={1}>
        <IconLogo width={120} height={41} />
        <Text
          style={{ fontSize: '5rem' }}
          className="text-danger font-bold mt-24"
        >
          404
        </Text>
        <Title level={1} className="mt-8">
          ページが見つかりません。
        </Title>
        <Text className="mt-24">
          入力したアドレスが間違っているか、ページが移動した可能性があります。
        </Text>
        <Link to={ROUTES_PATH.root}>
          <Button type="primary" className="mt-24">
            ホームへ戻る
          </Button>
        </Link>
      </Flex>
    </Card>
  );
}
